import React, { FC } from 'react';
import type { Event } from '@mb/types';
import { useIntl } from 'react-intl';
import { definedTranslation } from '../../i18n';

interface EventInfoProps {
  event: Event | null;
}

export const EventInfo: FC<EventInfoProps> = ({ event }) => {
  if (!event) return null;
  const intl = useIntl();
  const titleInfo = intl?.formatMessage(definedTranslation.title.information);
  const mappedInfo: any[] = [];
  if (event.company)
    mappedInfo.push({
      label: intl?.formatMessage(definedTranslation.label.organizingCompany),
      content: event.company,
    });
  if (event.fees)
    mappedInfo.push({
      label: intl?.formatMessage(definedTranslation.label.fees),
      content: event.fees,
    });
  if (event.registration)
    mappedInfo.push({
      label: intl?.formatMessage(definedTranslation.label.registration),
      content: event.registration,
    });
  if (event.documentation)
    mappedInfo.push({
      label: intl?.formatMessage(definedTranslation.label.documentation),
      content: event.documentation,
    });
  return (
    <div className="event-info w-full flex flex-col gap-8">
      <h2 className="event-info-title text-lg font-bold lg:text-xl">
        {titleInfo}
      </h2>
      <div className="event-info-cards grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {mappedInfo.map((info, index) => (
          <div
            className="event-info-card w-full flex flex-col p-6 gap-2 rounded-[16px] bg-[#F5F5F6]"
            key={index}
          >
            <p className="event-info-card-title font-bold text-[20px] m-0 lg:text-lg">
              {info.label}
            </p>
            <div className="event-info-card-content">
              <div
                dangerouslySetInnerHTML={{
                  __html: info.content,
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
